import { useProcessCatalog } from "@via/hooks/useProcessCatalog.ts";

/**
 * Whether the signed in user may edit the tags of a process family.
 *
 * Tags belong to the family (process_gid), not to a revision, so a revision's write permission
 * does not answer this. The server decides it per family in the catalog, and the frontend never
 * derives it. False while the catalog is loading, when it fails, and for a family it does not
 * list, so the tags stay read only until the server has said otherwise.
 */
export const useFamilyTagAccess = (processGid: number | undefined): boolean => {
  const { data } = useProcessCatalog();
  if (processGid == null) return false;
  return (
    data?.some(item => item.processGid === processGid && item.canEditTags) ??
    false
  );
};
